// extracted by mini-css-extract-plugin
export var searchHeader = "_65-0";
export var searchHeaderDark = "_65-1";